import React from 'react'
import { __ } from '../services/translate'
import { Table } from 'reactstrap'
import moment from 'moment'

const prop = (key, obj) => obj[key] || '-'

export default ({ user }) => {
  return (
    <Table borderless>
      <tbody>
      <tr>
        <th scope="row">{__('Jméno a příjmení')}</th>
        <td>{prop('name', user)}</td>
      </tr>
      <tr>
        <th scope="row">{__('Email')}</th>
        <td>{prop('email', user)}</td>
      </tr>
      <tr>
        <th scope="row">{__('Telefon')}</th>
        <td>{prop('phone', user)}</td>
      </tr>
      <tr>
        <th scope="row">{__('Moji dopravci')}</th>
        <td>
          {user.subjects.map((subject, i) => (
            <div key={i}>
              <strong>{subject.name}</strong>
            </div>
          ))}
        </td>
      </tr>
      <tr>
        <th scope="row">{__('Moje licence')}</th>
        <td>{prop('licences', user).map((licence, i) => (
          <div key={i}>
            <strong>{licence.name}</strong><br/>
            {__('Platné od')}: {moment(licence.valid_from).format('DD.MM.YYYY HH:mm')} <br/>
            {__('Expirace')}: {moment(licence.valid_to).format('DD.MM.YYYY HH:mm')} <br/>
          </div>
        ))}</td>
      </tr>
      </tbody>
    </Table>
  )
}
